import OmniApiClient from "./base";

const RESOURCE = "/amazon";

export const amazonApi = {
  // Get all credentials
  getAll(params) {
    return OmniApiClient.get(`${RESOURCE}/`, { params });
  },

  // Get credential by ID
  get(id) {
    return OmniApiClient.get(`${RESOURCE}/${id}`);
  },

  // Create new credential
  create(data) {
    return OmniApiClient.post(`${RESOURCE}/`, data);
  },

  // Update credential
  update(id, data) {
    return OmniApiClient.put(`${RESOURCE}/${id}`, data);
  },

  // Delete credential
  delete(id) {
    return OmniApiClient.delete(`${RESOURCE}/${id}`);
  },

  // Test credentials (unsaved)
  test(data) {
    return OmniApiClient.post(`${RESOURCE}/test`, data);
  },

  // Test saved credential
  testSaved(id) {
    return OmniApiClient.post(`${RESOURCE}/${id}/test`);
  },

  // Check Hazmat status for ASINs
  checkHazmat(asins) {
    return OmniApiClient.post(`${RESOURCE}/hazmat_check`, { asins });
  },

  // Toggle active status
  toggleActive(id) {
    return OmniApiClient.post(`${RESOURCE}/${id}/toggle-active`);
  },

  // Sync FBA orders for a date range into the DB
  // marketplaces: array of 2-letter codes e.g. ["DE","FR"] — defaults to DE,FR,PL,SE,NL,BE,ES,IT on the server
  syncOrders(start_date, end_date, marketplaces) {
    const params = { start_date, end_date };
    if (marketplaces && marketplaces.length) {
      params.marketplaces = marketplaces.join(",");
    }
    return OmniApiClient.post(`${RESOURCE}/orders/sync`, null, { params });
  },

  // Reports — builds repeated query params so FastAPI receives List[str] correctly.
  // reportOptions (Dict) is sent as JSON body since it cannot be a query param.
  retrieveReport({
    reportType,
    marketplaceIds,
    dataStartTime,
    dataEndTime,
    reportOptions,
  }) {
    const qs = new URLSearchParams();
    qs.append("reportType", reportType);
    (marketplaceIds || []).forEach((id) => qs.append("marketplaceIds", id));
    if (dataStartTime) qs.append("dataStartTime", dataStartTime);
    if (dataEndTime) qs.append("dataEndTime", dataEndTime);
    return OmniApiClient.post(
      `${RESOURCE}/reports/retrieve?${qs.toString()}`,
      reportOptions ? reportOptions : null,
      { responseType: "blob" },
    );
  },
};
